const AppRoutes = {
    viewUser: "/view-user",
    viewProducts: "/view-products",
    listUsers: "/list-users",
    listEvents: "/list-events",
    listStores: "/list-stores",
    allProducts: "/all-products",
    listSubsPay: "/list-subscription-payments",
    notifyUsers: "/notify-users",
    updateProduct: "/update-product",
    updateEvent: "/update-event",
    listChats: "/list-chats",
    listPosts: "/list-posts",
    listHashtagPosts: "/list-hashtag-posts",
    listHashtagUsers: "/list-hashtag-users", // New route
    viewChat: "/view-chat",
    home: "/home",
    login: "/",
    helpAndFeedback: "/help-and-feedback",
    deleteAccount: "/delete-account"


}
export default AppRoutes